export enum AdvertCardTypeEnum {
	HORIZONTAL = '0',
	VERTICAL_BIG = '1',
	VERTICAL_SMALL = '2',
}
